import React from 'react'
import { motion } from 'framer-motion'

const TileDisplay = ({ title, tiles, bgColor, textColor }) => {
  if (!tiles || tiles.length === 0) return null

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="w-full"
    >
      <div className="flex flex-col items-center gap-3">
        <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
        <div className="flex flex-wrap justify-center gap-2">
          {tiles.map((tile, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1, duration: 0.2 }}
              className={`px-4 py-3 rounded-lg font-bold text-lg min-w-[3rem] text-center shadow-sm border`}
              style={{ 
                backgroundColor: bgColor, 
                color: textColor, 
                borderColor: textColor + '20' 
              }}
            >
              {tile}
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  )
}

export default TileDisplay